import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stripe-token',{staticClass:"col-12",attrs:{"publishable-key":_vm.paymentMethod.publishableKey},on:{"token":function($event){return _vm.$emit('token', { source: $event })}},scopedSlots:_vm._u([{key:"after",fn:function(ref){
var submit = ref.submit;
var loading = ref.loading;
return [_c('div',{staticClass:"d-flex justify-end mt-8"},[_c(VBtn,{attrs:{"color":"primary","depressed":"","loading":loading,"disabled":loading},on:{"click":submit}},[_c('span',[_vm._v(_vm._s(_vm.t('Proceed')))])])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }